import EventEmitter from "events";
import { DataTrackingClient } from "../core";
import { Logger } from "../utils/logger";
import { Utility } from "../utils/utility";
export class XHRInterceptor {
    constructor() {
        this._emitter = new EventEmitter();
        this._trackingItems = [];
        if (XHRInterceptor._instance) {
            throw new Error("Singleton class [FormSubmissionMonitor] can't be instantiated more than once. Call getInstance() instead");
        }
    }
    static getInstance() {
        if (!XHRInterceptor._instance) {
            XHRInterceptor._instance = new XHRInterceptor();
        }
        return XHRInterceptor._instance;
    }
    addItem(objTrackingItem) {
        this._trackingItems.push(objTrackingItem);
    }
    on(eventName, callBack) {
        this._emitter.on(eventName, (e) => {
            callBack.call(this, e);
        });
    }
    init() {
        ((open) => {
            XMLHttpRequest.prototype.open = function (method, url, async, username, password) {
                this._requestUrl = url;
                this._requestMethod = method;
                open.call(this, method, url, async ? async : false, username, password);
            };
        })(XMLHttpRequest.prototype.open);
        ((send, xhrInterceptor) => {
            XMLHttpRequest.prototype.send = function (body) {
                Logger.info("Doing AJAX Call");
                Logger.verbose("URL: " + this._requestUrl);
                Logger.verbose("Data");
                Logger.verbose(body);
                send.call(this, body);
                this._data = body;
                if (this._requestUrl.indexOf(DataTrackingClient.getInstance().apiHost + '/api') === -1) { // Don't track our own API calss
                    ((onreadystatechange, xhrInterceptor) => {
                        this.onreadystatechange = function (e) {
                            onreadystatechange === null || onreadystatechange === void 0 ? void 0 : onreadystatechange.call(this, e);
                            if (this.readyState == 4) { /* complete */
                                Logger.info("Ajax call complete. Finding matching tracking element.");
                                let trackingItem = xhrInterceptor._ifNeedToTrack(this);
                                if (trackingItem) {
                                    xhrInterceptor._emitter.emit("complete", { xhr: this, item: trackingItem });
                                }
                                else {
                                    Logger.info("No matching element was found. Not triggering ajax complete.");
                                }
                            }
                        };
                    })(this.onreadystatechange, xhrInterceptor);
                }
            };
        })(XMLHttpRequest.prototype.send, this);
    }
    _ifNeedToTrack(xhr) {
        let ret = null;
        for (let i = 0; i < this._trackingItems.length; i++) {
            Logger.verbose("Matching with element");
            Logger.verbose(this._trackingItems[i]);
            if (this._trackingItems[i].formConfig) {
                if (this._checkIfRequestMatchesConfig(xhr, this._trackingItems[i].formConfig, true)) {
                    ret = this._trackingItems[i];
                    break;
                }
            }
            else if (this._trackingItems[i].ajaxConfig) {
                if (this._checkIfRequestMatchesConfig(xhr, this._trackingItems[i].ajaxConfig, false)) {
                    ret = this._trackingItems[i];
                    break;
                }
            }
        }
        return ret;
    }
    _checkIfRequestMatchesConfig(xhr, config, isFormSubmission) {
        let _xhr = xhr;
        let shouldTrack = false;
        if (isFormSubmission) {
            Logger.info("This is an Ajax call as a part of a form submission");
        }
        else {
            Logger.info("This is a normal Ajax call");
        }
        // Handle Form submission checking                 
        if (_xhr._requestUrl.indexOf(config.ajaxURL) >= 0) {
            shouldTrack = true;
            if (config.formFieldName != "") {
                shouldTrack = false;
                Logger.info("Checking if a data key exists in the data being posted and if its value matches with the configuration");
                let fields = config.formFieldName.split(",").map((val) => { return val.replace(/^\s+|\s+$/g, ''); });
                let values = config.formFieldValue.split(",").map((val) => { return val.replace(/^\s+|\s+$/g, ''); });
                if ((fields.length != values.length)) {
                    Logger.error("Field count and value count does not match");
                }
                else {
                    if (config.dataType == "FormData") {
                        try {
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (_xhr._data.get(fields[i]) != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("XHRInterceptor:: Error in checking data key (dataType => FormData)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "Object") {
                        try {
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (_xhr._data[fields[i]] != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("XHRInterceptor:: Error in checking data key (dataType => Object)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "JSONString") {
                        try {
                            let tmp = JSON.parse(_xhr._data);
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (tmp[fields[i]] != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("XHRInterceptor:: Error in checking data key (dataType => JSONString)");
                            //Logger.verbose(ex);
                        }
                    }
                    else if (config.dataType == "URLSearchParams") {
                        try {
                            let params = new URLSearchParams(_xhr._data);
                            shouldTrack = true;
                            for (let i = 0; i < fields.length; i++) {
                                if (params.get(fields[i]) != values[i]) {
                                    shouldTrack = false;
                                    break;
                                }
                            }
                        }
                        catch (ex) {
                            shouldTrack = false;
                            Logger.error("XHRInterceptor:: Error in checking data key (dataType => URLSearchParams)");
                            //Logger.verbose(ex);
                        }
                    }
                    if (!shouldTrack) {
                        Logger.info("No matching data key found as per the configuraton.");
                    }
                }
            }
            if (shouldTrack) {
                /* This ajax call is a part of a form submission, so we must check the response to see if the submission was successful. */
                Logger.info("Checking if form submission was successful");
                if (isFormSubmission && !this._checkFormSubmissionStatus(xhr, config)) {
                    shouldTrack = false;
                }
            }
        }
        return shouldTrack;
    }
    _checkFormSubmissionStatus(xhr, formConfig) {
        let submitSuccess = false;
        let ajaxResponse = xhr.responseText;
        if (formConfig.ajaxReturnType == "json") {
            try {
                ajaxResponse = JSON.parse(ajaxResponse);
                let success_response = Utility.getObjectValueAtPath(ajaxResponse, formConfig.ajaxSuccessJsonObject, null);
                if (success_response && success_response.indexOf(formConfig.ajaxSuccessValue) >= 0) {
                    submitSuccess = true;
                    Logger.info("Form submission was succesful");
                }
                else {
                    Logger.info("Form submission was unsuccesful");
                }
            }
            catch (ex) {
                //Do nothing
                Logger.error("Error in checking response");
                Logger.verbose(ex);
            }
        }
        else if (formConfig.ajaxReturnType == "text") {
            if (ajaxResponse.indexOf(formConfig.ajaxSuccessValue) >= 0) {
                Logger.info("Form submission was succesful");
                submitSuccess = true;
            }
            else {
                Logger.info("Form submission was unsuccesful");
            }
        }
        return submitSuccess;
    }
}
XHRInterceptor._instance = null;
